export default __webpack_public_path__ + "static/media/freshdesk.a0b60d27.svg";